import { BillboardResponse } from '../dto/ResDtoRepository';
import { UpdateBillboardReq } from '../dto/ReqDtoRepository';
import { sendApiRequest, sendGetApiRequest } from './apiConfig';


export const getBillboard = async (aui: string): Promise<BillboardResponse> => {
  return sendGetApiRequest<BillboardResponse>(`/api/v1/billboard?aui=${aui}`);
};

export const getBillboardForOwner = async (aui: string): Promise<BillboardResponse> => {
  return sendApiRequest<BillboardResponse>('get', `/api/v1/billboard/owner?aui=${aui}`);
};

export const updateBillboard = async (aui: string, data: UpdateBillboardReq): Promise<BillboardResponse> => {
  return sendApiRequest<BillboardResponse>('put', `/api/v1/billboard?aui=${aui}`, data);
};